<div class="d-flex justify-content-end border-top flex-wrap">
  <span class="btn btn-sm">Actions:</span>
  <era-device-os-update-continue-ui [device]="device()"
                                    (continueClicked)="continue($event)">
  </era-device-os-update-continue-ui>
  <era-device-os-update-reset-ui [device]="device()"
                                 (resetClicked)="reset($event)">
  </era-device-os-update-reset-ui>
</div>